module.exports = __webpack_public_path__ + "static/holly-cam-3fe2f7c6a9a6f14394ba441cf30ad1a3.jpg";